export default __webpack_public_path__ + "static/media/4.886546a6.png";